import { PocRadio } from 'commons/components/components-wrapper/poc-radio.component';
import { useTranslation } from 'core/i18n/i18n';
import { EAP_TYPE_OPTIONS, EapType } from 'modules/settings/pods/settings-devices/settings-devices-menu.model';
import {
    EapFormCard,
    EapFormTitle,
    EapPocRadioGroup,
} from 'modules/settings/pods/settings-devices/settings-devices-eap-settings/settings-devices-eap-settings-form/settings-devices-eap-settings-form.style';
import { EapSettingsFormProtocolModel } from './eap-settings-form-protocol.model';
import { EapSettingsFormPeap } from './forms/eap-settings-form-peap-protocol/eap-settings-form-peap-protocol.component';
import { EapSettingsFormTls } from './forms/eap-settings-form-tls-protocol/eap-settings-form-tls-protocol.component';
import { EapSettingsFormTtls } from './forms/eap-settings-form-ttls-protocol/eap-settings-form-ttls-protocol.component';

interface EapSettingsFormProtocolProps {
    data: EapSettingsFormProtocolModel;
    onDataChange?: <K extends keyof EapSettingsFormProtocolModel>(
        propertyName: K,
        value: EapSettingsFormProtocolModel[K]
    ) => void;
}

export const EapSettingsFormProtocol = ({ data, onDataChange }: EapSettingsFormProtocolProps) => {
    const { t } = useTranslation();
    return (
        <EapFormCard>
            <div>
                <EapFormTitle>
                    {t('settings.devices.eap-settings.eap-config-create-form.form.field.protocol')}
                </EapFormTitle>
                <EapPocRadioGroup
                    name="eapType"
                    direction={'vertical'}
                    value={data.eapType}
                    onValueChange={(value) => {
                        onDataChange?.('eapType', value.detail as EapType);
                    }}
                >
                    {EAP_TYPE_OPTIONS.map((option) => (
                        <PocRadio key={option.value} value={option.value}>
                            {option.label}
                        </PocRadio>
                    ))}
                </EapPocRadioGroup>
            </div>
            <div>
                {data.eapType === 'PEAP' && <EapSettingsFormPeap data={data} onDataChange={onDataChange} />}
                {data.eapType === 'TLS' && <EapSettingsFormTls data={data} onDataChange={onDataChange} />}
                {data.eapType === 'TTLS' && <EapSettingsFormTtls data={data} onDataChange={onDataChange} />}
            </div>
        </EapFormCard>
    );
};
